import script from "./PDFPreviewerDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PDFPreviewerDialog.vue?vue&type=script&setup=true&lang=js"

import "./PDFPreviewerDialog.vue?vue&type=style&index=0&id=11501664&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11501664"]])

export default __exports__